import { WebPlugin } from '@capacitor/core';
export class PrintVWeb extends WebPlugin {
    testingMessage() {
        console.log('Imprimiendo desde la web');
        return true;
    }
    getNotifications() {
        console.log('Imprimiendo desde la web');
        return true;
    }
    blPrint(options) {
        console.log(options);
        console.log(options.value);
        return true;
    }
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
}
//# sourceMappingURL=web.js.map